
import QrcodeVue from 'qrcode.vue'
import { defineComponent, onMounted, onBeforeUnmount, reactive, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { LogoffVerifyStatus, OfficialLogoffService } from './official-logoff.service'
import LogoffVerificationFailModal from './logoffVerificationFailModal.vue'

/** 公众号登录 */
export default defineComponent({
  name: 'OfficialLogin',
  components: {
    QrcodeVue,
    LogoffVerificationFailModal
  },
  props: {
    size: {
      type: Number,
      default: 180
    },
  },
  emits: ['verifySuccess'],
  setup(_props, { emit }) {
    let isDestroy = false // 用于劫持异步
    const injector = useReflectiveInjector([OfficialLogoffService])
    const service = injector.get(OfficialLogoffService)

    const viewModel = reactive({
      qrText: '',
      retry: false,
      verifyTicket: '',
      loopTimer: null,
      expiryTimer: null,
      loopVerifyTime: 2000,
      quickLoginRes: null, // 快速登录返回结果
    })

    const verificationStatus = ref<LogoffVerifyStatus>(LogoffVerifyStatus.Pending)

    onMounted(() => loadLogoffQrCode())

    onBeforeUnmount(() => {
      isDestroy = true
      clearExpiryTimer()
      clearLoopVerify()
    })

    /**
     * @description 加载注销登录二维码
     */
    function loadLogoffQrCode() {
      service.requestOfficialQrcode().then(res => {
        if (isDestroy) {
          return
        }

        if (!res.qrcode_url) {
          viewModel.retry = true
          return
        }

        viewModel.retry = false
        viewModel.qrText = res.qrcode_url
        viewModel.verifyTicket = res.verify_ticket

        loopVerify()

        expireReloadQrcode(res.expire_seconds * 1000)
      }).catch(() => {
        qrRetry()
      })
    }

    /**
     * @description 过期重新加载二维码
     */
    function expireReloadQrcode(wait: number) {
      clearExpiryTimer()
      viewModel.expiryTimer = setTimeout(() => qrRetry(), wait)

      // login.report({
      //   show_time: login.reportCurrentDate(),
      //   login_act: 1,
      //   reason: '二维码过期'
      // })
    }

    /**
     * @description 启动是否关注公众号轮询
     */
    function loopVerify() {
      clearLoopVerify()
      viewModel.loopTimer = setInterval(() => verifyOfficial(), viewModel.loopVerifyTime)
    }

    /**
     * @description 清除是否注销登录校验定时器标识
     */
    function clearLoopVerify() {
      clearInterval(viewModel.loopTimer)
    }

    /**
     * @description 清除二维码过期定时器标识
     */
    function clearExpiryTimer() {
      clearTimeout(viewModel.expiryTimer)
    }

    /**
     * @description 二维码错误
     */
    function qrRetry() {
      viewModel.retry = true
      clearLoopVerify()
    }

    /**
     * 是否通过注销登录校验
     */
    function verifyOfficial() {
      const params = { verify_ticket: viewModel.verifyTicket }
      service.requestOfficialVerify(params).then(res => {
        if (res.status === LogoffVerifyStatus.Failed) {
          verificationStatus.value = LogoffVerifyStatus.Failed
          return
        }

        if (res.close_token) {
          clearLoopVerify()
          emit('verifySuccess', res.close_token)
          return
        }

        loopVerify()
      })
    }

    function retryVerify() {
      verificationStatus.value = LogoffVerifyStatus.Pending
      clearExpiryTimer()
      clearLoopVerify()
      loadLogoffQrCode()
    }

    return {
      viewModel,
      loadLogoffQrCode,
      verificationStatus,
      LogoffVerifyStatus,
      retryVerify
    }
  }
})

